import { createReducer } from "reduxsauce";

//Custom Imports
import { apiFetchedState, getInitialPendingState } from "@actions/redux.action";
import { vacationType } from "./actionTypes";

const initialState = {
  vacationDetails: {
    data: [],
    api: getInitialPendingState(),
  },
};

const setSuccessStatus = (key, newStatus) => (state, action) => ({
  ...state,
  [key]: {
    ...state[key],
    data: action.payload,
    api: apiFetchedState(newStatus, state[key].api),
  },
});
const setStatus = (key, newStatus) => (state) => ({
  ...state,
  [key]: {
    ...state[key],
    api: apiFetchedState(newStatus, state[key].api),
  },
});

const actionHandlers = {
  [vacationType.GET_VACATION_DATA_UPCOMING]: setStatus("vacationDetails", {
    pending: true,
  }),
  [vacationType.GET_VACATION_DATA_SUCCESS]: setSuccessStatus(
    "vacationDetails",
    {
      success: true,
    },
  ),
  [vacationType.GET_VACATION_DATA_ERROR]: setStatus("vacationDetails", {
    error: true,
  }),
  [vacationType.GET_VACATION_DATA_FETCHED]: setStatus("vacationDetails", {
    fetched: true,
  }),
};

export default createReducer(initialState, actionHandlers);
